import RequestSummaryResourceModel from '../../generated/types/model/resource/RequestSummaryResourceModel';

export default class RequestSummaryResourceViewModel extends RequestSummaryResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
